import { Component } from 'react';
import { PX_PDF_ELEMENT_ID } from '../pages/ReceiptsRightPanel';
import { track } from '../tracking';

interface PDFViewerProps {
    id?: string;
    primaryUrl: string;
    fallbackUrl: string;
}

type State = {
    isFailed: boolean;
};

export class PDFViewer extends Component<PDFViewerProps, State> {
    state = {
        isFailed: false,
    };

    componentDidMount(): void {
        window.addEventListener('message', this.handleMessage);
    }

    componentWillUnmount(): void {
        window.removeEventListener('message', this.handleMessage);
    }

    handleMessage = async (event: MessageEvent): Promise<void> => {
        if (event.data.type === 'PDF_FETCH_FAILED') {
            console.log('PDFViewer received message:', event.data);
            this.setState({ isFailed: true });
            track('WARN', {
                on: 'PDFViewer',
                message: 'PDFViewer received message',
                primaryUrl: this.props.primaryUrl,
                fallbackUrl: this.props.fallbackUrl,
                data: event.data,
            });
        }
    };

    render(): JSX.Element {
        const { isFailed } = this.state;
        const { id, primaryUrl, fallbackUrl } = this.props;
        const url = isFailed ? fallbackUrl : primaryUrl;

        return (
            <iframe
                key={url}
                id={id || PX_PDF_ELEMENT_ID}
                className="w-full h-full fade-in"
                src={`/pdfjs-3/web/viewer.html?file=${url}`}
                style={{ backgroundColor: 'rgb(53,53,53)' }}
            />
        );
    }
}
